module.exports = __webpack_public_path__ + "img/notice_ready_pro.c1818634.jpg";